"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookie = void 0;
const getCookie = (name) => {
    var re = new RegExp(name + "=([^;]+)");
    var value = re.exec(document.cookie);
    return value != null ? unescape(value[1]) : null;
};
exports.getCookie = getCookie;
